import commonService from "./common-service";

class PriceCodesService {
  async getPriceCodesData(payor, group, unique) {
    try {
      const response = await commonService.getFromServer("EOM/PriceCodes", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createData(params) {
    try {
      let response = await commonService.postToServer("EOM/PriceCodes", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/PriceCodes/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
      await commonService.downloadFromServer("EOM/PriceCodes/Download", {
        fileName: "PriceCodes.xlsx",
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateData(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/PriceCodes/" + params?.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getData(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/PriceCodes/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteData(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/PriceCodes/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting data");
      }
    } catch (e) {
      throw new Error("Error deleting data");
    }
  }
}
export default new PriceCodesService();
